import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Container, Row, Col } from "shards-react";
import { useLocation } from "react-router-dom";
import PageTitle from "../components/common/PageTitle";
import SmallStats from "../components/common/SmallStats";
import UserDetails from "./../components/detection-profile/UserDetails";
import UserActivity from "./../components/detection-profile/UserActivity";
import './loaderStyles.css';
import { useAuth } from '../context/AuthContext';
const OnlineStore = ({ smallStats }) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const uuid = queryParams.get("uuid");

  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState(null);
  const { logout } = useAuth(); 
  // Fetch the data from the API
  useEffect(() => {
    const fetchData = async () => {
      try {
      //  const companyId = localStorage.getItem('company_id');
        const token = localStorage.getItem("token");
      //  const comp_id=localStorage.getItem('company_id');
       // const token=localStorage.getItem('token');
        
        if(!token||token==''){ 
         logout();
       }

       
        setIsLoading(true);

        const response = await fetch('https://vaptlabreport.com/shieldapi/overall_metrcis_info.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' ,
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ uuid: [uuid] })
        });
        const result = await response.json();
        setData(result.data);
      } catch (error) {
        console.error("Error fetching data", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [uuid]);

  // Helper function to calculate relative time
  const getRelativeTime = (lastSeenEpoch) => {
    const lastSeen = new Date(lastSeenEpoch); // Convert epoch timestamp to Date object
    const now = new Date();
    const differenceInMs = now - lastSeen;
//console.log(data.last_see);
    const seconds = Math.floor(differenceInMs / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (days > 0) return `${days} day${days > 1 ? 's' : ''} ago`;
    if (hours > 0) return `${hours} hour${hours > 1 ? 's' : ''} ago`;
    if (minutes > 0) return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
    return `${seconds} second${seconds > 1 ? 's' : ''} ago`;
  };

  // Update stats with fetched data
  const updatedSmallStats = (smallStats || []).map((stat) => {
    if (stat.label === "PratiBandh ID") {
      return { ...stat, value: uuid || stat.value };
    }

    if (data) {
      if (stat.label === "Last Seen" && data.last_seen_date) {
        const relativeTime = getRelativeTime(data.last_seen_time); // Calculate relative time
        return { ...stat, value: relativeTime };
      }

      if (stat.label === "Unique Apps") {
        return { ...stat, value: data.unique_app_names_count || stat.value };
      }

      if (stat.label === "Device Used By") {
        return { ...stat, value: data.unique_devices || stat.value };
      }
    }

    return stat;
  });

  return (
    <Container fluid className="main-content-container px-4">
      <Row noGutters className="page-header py-4">
        <PageTitle title="" subtitle="" className="text-sm-left mb-3" />
      </Row>

      <Row>
        {updatedSmallStats.map((stats, idx) => (
          <Col key={idx} md="6" lg="3" className="mb-4">
            <SmallStats
              id={`small-stats-${idx}`}
              chartData={stats.datasets}
              chartLabels={stats.chartLabels}
              label={<h6 className="m-0">{stats.label}</h6>}
              value={
                isLoading ? (
                  <div className="spinner" />
                ) : (
                  <span
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      fontSize: "0.99rem",
                      paddingTop: "8px",
                    }}
                  >
                    {stats.value}
                  </span>
                )
              }
              percentage={stats.percentage}
              increase={stats.increase}
              decrease={stats.decrease}
            />
          </Col>
        ))}
      </Row>

      <Row>
        <Col lg="8">
          <UserActivity title="Detection History" uuid={uuid} />
        </Col>
        <Col lg="4" sm="12">
          <UserDetails uuid={uuid} health="25" />
        </Col>
      </Row>
    </Container>
  );
};

OnlineStore.propTypes = {
  smallStats: PropTypes.array,
};

OnlineStore.defaultProps = {
  smallStats: [
    {
      label: "PratiBandh ID",
      value: "XXXXXXXXXXXX",
      percentage: "0",
      increase: true,
      datasets: [{ label: "Today", fill: "start", borderWidth: 1.5, data: [0] }],
    },
    {
      label: "Last Seen",
      value: "XXXX",
      percentage: "0",
      increase: false,
      decrease: true,
      datasets: [{ label: "Today", fill: "start", borderWidth: 1.5, data: [0] }],
    },
    {
      label: "Unique Apps",
      value: "XXXX",
      percentage: "0",
      increase: true,
      datasets: [{ label: "Today", fill: "start", borderWidth: 1.5, data: [0] }],
    },
    {
      label: "Device Used By",
      value: "XXX",
      percentage: "0",
      increase: false,
      decrease: true,
      datasets: [{ label: "Today", fill: "start", borderWidth: 1.5, data: [0] }],
    },
  ],
};

export default OnlineStore;
